import React from 'react'
import Layout from '../../components/layout'
import Container from '../../components/container'
// import styled from '@emotion/styled'

const EventPage = () => {
  return (
    <Layout>
      <Container>
        <p>This is the Event Page</p>
      </Container>
    </Layout>
  );
}

export default EventPage
